const READINESS_MAX = 150;

function toNumber(value) {
  if (value == null || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

function roundHalfToEven(value, places) {
  const factor = 10 ** places;
  const scaled = Math.round(value * factor * 1e6) / 1e6;
  const floored = Math.floor(scaled);
  const diff = scaled - floored;
  if (diff > 0.5) return (floored + 1) / factor;
  if (diff < 0.5) return floored / factor;
  return (floored % 2 === 0 ? floored : floored + 1) / factor;
}

/** Rule 13: value(r) = min + (r / 150) × (max − min), rounded to the currency's decimal places. */
export function readinessAmount(minAmount, maxAmount, readiness, decimalPlaces = 2) {
  const min = toNumber(minAmount);
  const max = toNumber(maxAmount);
  if (min == null || max == null) return null;
  return roundHalfToEven(min + (readiness / READINESS_MAX) * (max - min), decimalPlaces);
}

export function rangePenetration(readiness) {
  return Math.floor((readiness / READINESS_MAX) * 100);
}
